<template>
  <div :id="`${source}_campaign_channel_cell_${row.id}`" class="flex items-center gap-3 ml-2.5">
    <div class="flex items-center justify-center w-9 h-9 rounded-xl bg-[var(--white-opacity-8)] shrink-0">
      <ThemeImage
        :icon="channelIcon"
        :alt="`${row.channel || 'email'}_icon`"
        class="w-5 h-5"
      />
    </div>
    <span
      :title="row.name"
      class="overflow-hidden text-ellipsis whitespace-nowrap max-w-[300px] block text-sm"
    >
      {{ row.name }}
    </span>
  </div>
</template>

<script setup>
import { computed } from "vue";
import ThemeImage from "@/src/components/ThemeImage.vue";
import { campaignChannelIcons } from "@/src/constants/campaignInEngageConstants.js";

const props = defineProps({
  row: { type: Object, required: true },
  source: { type: String, default: "campaign" },
});

const channelIcon = computed(() => {
  const channel = props.row.channel?.toLowerCase();
  return campaignChannelIcons[channel] || campaignChannelIcons.email;
});
</script>

